module.exports = __webpack_public_path__ + "static/media/Gen_07_rescan.3a754de1.jpg";